/*! rb-age-verify-v1 — single source of truth for the 21+ attestation and how long it lasts.
 *
 * The attestation was previously stored as the literal string "1" with no timestamp, so once a
 * visitor clicked through they were never asked again on that browser — indefinitely. A periodic
 * re-ask is the stronger good-faith record, and 90 days costs effectively nothing in conversion.
 *
 * Two files read this flag at different points in the page lifecycle — rb-cookie-hold.js in the
 * head, before the Consentmo embed mounts, and rb-age-gate.js deferred in the body — so the check
 * lives here rather than being copy-pasted into both, where the TTL constant would eventually
 * drift between them.
 *
 * Stored value is now a millisecond timestamp of when the visitor attested. Legacy "1" values are
 * treated as valid and restamped on first read, so the change does not re-gate the entire existing
 * audience at once; their 90 days run from their next visit instead.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'rb_age_verified';
  var TTL_DAYS = 90;
  var TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

  function read() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return null;
    }
  }

  function write(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (err) {
      /* private mode — the visitor is simply asked again next time */
    }
  }

  function clear() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (err) {}
  }

  function setVerified() {
    write(String(Date.now()));
  }

  function isVerified() {
    var raw = read();
    if (!raw) return false;

    /* Pre-TTL value. Honour it once and restamp, so existing visitors are not all re-gated
       the moment this ships. Also what scripts/rb-preview-shot.mjs writes to skip the gate. */
    if (raw === '1') {
      setVerified();
      return true;
    }

    var stamped = parseInt(raw, 10);
    if (!stamped || stamped <= 0) {
      clear();
      return false;
    }

    /* A stamp in the future means the device clock moved backwards, not that the attestation is
       invalid, so only elapsed time past the TTL expires it. */
    if (Date.now() - stamped > TTL_MS) {
      clear();
      return false;
    }
    return true;
  }

  window.rbAgeVerify = {
    STORAGE_KEY: STORAGE_KEY,
    TTL_DAYS: TTL_DAYS,
    isVerified: isVerified,
    setVerified: setVerified,
  };
})();
